var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNklogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 241,
    height: 69,
    viewBox: "0 0 241 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(-0.05 0.299)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "the",
    transform: "translate(0.05 54.701)",
    fill: "#100f10",
    fontSize: 54,
    fontFamily: "GloucesterMT-ExtraCondensed, Gloucester MT"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "the")), /*#__PURE__*/React.createElement("text", {
    id: "Keeper",
    transform: "translate(135.05 54.701)",
    fill: "#100f10",
    fontSize: 53,
    fontFamily: "GloucesterMT-ExtraCondensed, Gloucester MT"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Keeper")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    transform: "translate(47.05 -0.299)",
    fill: "#100f10",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 68,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 67,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "nail",
    transform: "translate(60.05 55.701)",
    fill: "#fff",
    fontSize: 59,
    fontFamily: "GloucesterMT-ExtraCondensed, Gloucester MT",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "nail")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNklogo);
export default __webpack_public_path__ + "static/media/nklogo.2ffc6793629b5676a8faba893b6de673.svg";
export { ForwardRef as ReactComponent };